import Viewer from './parts/Viewer';
import Editor from './parts/Editor';

const RichTextEditor = {
  Viewer,
  Editor
};

export default RichTextEditor;